import React from 'react';

const ConfirmDialog = ({ isOpen, title, message, onConfirm, onCancel, confirmText = '確認', cancelText = 'キャンセル', type = 'warning' }) => {
  if (!isOpen) return null;

  const getTypeStyles = () => {
    switch (type) {
      case 'danger':
        return {
          bg: 'bg-gradient-to-br from-red-50 to-orange-50',
          border: 'border-red-300',
          icon: '🚪',
          iconBg: 'bg-red-100',
          confirmBtn: 'bg-red-600 hover:bg-red-700',
        };
      case 'warning':
        return {
          bg: 'bg-gradient-to-br from-yellow-50 to-orange-50',
          border: 'border-yellow-300',
          icon: '⚠️',
          iconBg: 'bg-yellow-100',
          confirmBtn: 'bg-yellow-600 hover:bg-yellow-700',
        };
      case 'info':
        return {
          bg: 'bg-gradient-to-br from-blue-50 to-indigo-50',
          border: 'border-blue-300',
          icon: '🧊',
          iconBg: 'bg-blue-100',
          confirmBtn: 'bg-blue-600 hover:bg-blue-700',
        };
      case 'orange':
        return {
          bg: 'bg-gradient-to-br from-orange-50 to-amber-50',
          border: 'border-orange-300',
          icon: '🔥',
          iconBg: 'bg-orange-100',
          confirmBtn: 'bg-orange-600 hover:bg-orange-700',
        };
      case 'purple':
        return {
          bg: 'bg-gradient-to-br from-purple-50 to-pink-50',
          border: 'border-purple-300',
          icon: '🌊',
          iconBg: 'bg-purple-100',
          confirmBtn: 'bg-purple-600 hover:bg-purple-700',
        };
      case 'green':
        return {
          bg: 'bg-gradient-to-br from-green-50 to-emerald-50',
          border: 'border-green-300',
          icon: '🛒',
          iconBg: 'bg-green-100',
          confirmBtn: 'bg-green-600 hover:bg-green-700',
        };
      case 'pink':
        return {
          bg: 'bg-gradient-to-br from-pink-50 to-rose-50',
          border: 'border-pink-300',
          icon: '❤️',
          iconBg: 'bg-pink-100',
          confirmBtn: 'bg-pink-600 hover:bg-pink-700',
        };
      default:
        return {
          bg: 'bg-gradient-to-br from-gray-50 to-slate-50',
          border: 'border-gray-300',
          icon: '💭',
          iconBg: 'bg-gray-100',
          confirmBtn: 'bg-gray-600 hover:bg-gray-700',
        };
    }
  };

  const styles = getTypeStyles();

  return (
    <div className="fixed inset-0 z-[10001] flex items-center justify-center p-4 animate-fadeIn">
      {/* 背景オーバーレイ */}
      <div 
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onCancel}
      />
      
      {/* ダイアログボックス */}
      <div 
        className={`relative ${styles.bg} rounded-2xl shadow-2xl border-2 ${styles.border} max-w-md w-full transform transition-all animate-scaleIn`}
        style={{
          animation: 'scaleIn 0.2s ease-out',
        }}
      >
        {/* アイコン */}
        <div className="flex justify-center pt-6">
          <div className={`${styles.iconBg} rounded-full w-16 h-16 flex items-center justify-center text-3xl shadow-md`}>
            {styles.icon}
          </div>
        </div>

        {/* タイトル */}
        <div className="px-6 pt-4 pb-2">
          <h3 className="text-xl font-bold text-gray-800 text-center">
            {title}
          </h3>
        </div>

        {/* メッセージ */}
        <div className="px-6 pb-6">
          <p className="text-gray-700 text-center whitespace-pre-line leading-relaxed">
            {message}
          </p>
        </div>

        {/* ボタン（onConfirmが指定されている場合のみ表示） */}
        {onConfirm && (
          <div className="flex gap-3 px-6 pb-6">
            <button
              onClick={onCancel}
              className="flex-1 px-4 py-3 bg-white border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors shadow-sm"
            >
              {cancelText}
            </button>
            <button
              onClick={onConfirm}
              className={`flex-1 px-4 py-3 ${styles.confirmBtn} text-white rounded-lg font-semibold transition-colors shadow-md`}
            >
              {confirmText}
            </button>
          </div>
        )}
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out;
        }
        
        .animate-scaleIn {
          animation: scaleIn 0.2s ease-out;
        }
      `}</style>
    </div>
  );
};

export default ConfirmDialog;
